import React from 'react';
import styled from 'styled-components';

interface CardProps {
    children: React.ReactNode;
    padding?: 'sm' | 'md' | 'lg';
}

export const Card: React.FC<CardProps> = ({ children, padding = 'md' }) => {
    return <StyledCard $padding={padding}>{children}</StyledCard>;
};

const StyledCard = styled.div<{ $padding: 'sm' | 'md' | 'lg' }>`
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  box-shadow: ${({ theme }) => theme.shadows.card};

  padding: ${({ $padding }) => {
        switch ($padding) {
            case 'sm':
                return '12px';
            case 'lg':
                return '28px';
            default:
                return '20px';
        }
    }};
`;
